module.exports = __webpack_public_path__ + "img/ปลาไพค.87d8b22b.jpg";